export const StatusData = [{ _id: "1", name: "Active" }, { _id: "0", name: "Inactive" }];
export const formatStatus = (status) => String(status) === "1" ? "Active" : "Inactive";
export const formatPermissions = (permissions) => Array.isArray(permissions) && permissions.length
  ? permissions.map((permission) => permission.name).join(", ") : "N/A";
